/**
 * Controlador de campos baseado no plano do usuário
 * Gerencia o bloqueio/desbloqueio de campos de marca e modelo
 */
class VehiclePlanController {
    constructor() {
        this.userPlan = null;
        this.plateField = null;
        this.brandField = null;
        this.modelField = null;
        this.initialized = false;

        this.init();
    }

    /**
     * Inicializar o controlador
     */
    init() {
        if (this.initialized) {
            return;
        }

        $(document).ready(() => {
            this.setupFields();

            // Só continuar se houver campos para controlar
            if (
                !this.plateField.length &&
                !this.brandField.length &&
                !this.modelField.length
            ) {
                return;
            }

            this.getUserPlan();
            this.setupEventListeners();
            this.applyPlanRules();
            this.initialized = true;
        });
    }

    /**
     * Configurar referências dos campos
     */
    setupFields() {
        this.plateField = $("#inputPlate");
        this.brandField = $("#inputBrand");
        this.modelField = $("#inputModel");
    }

    /**
     * Obter o plano do usuário através de uma meta tag ou variável global
     */
    getUserPlan() {
        // Tentar obter o plano através de meta tag
        const planMeta = $('meta[name="user-plan"]').attr("content");
        if (planMeta) {
            this.userPlan = planMeta;
            return;
        }

        // Tentar obter através de variável global (se disponível)
        if (typeof window.userPlan !== "undefined") {
            this.userPlan = window.userPlan;
            return;
        }

        // Fazer uma requisição AJAX para obter o plano
        this.fetchUserPlan();
    }

    /**
     * Buscar o plano do usuário via AJAX
     */
    fetchUserPlan() {
        // Verificar se estamos no backoffice - se sim, não fazer a chamada
        if (window.location.pathname.includes("/backoffice")) {
            this.userPlan = "essencial"; // Assumir plano básico no backoffice
            this.applyPlanRules();
            return;
        }

        $.ajax({
            url: "/api/user/plan",
            method: "GET",
            xhrFields: {
                withCredentials: true,
            },
            success: (response) => {
                this.userPlan = response.plan;
                this.applyPlanRules();
            },
            error: (xhr, status, error) => {
                // Assumir plano básico como fallback
                this.userPlan = "gratuito";
                this.applyPlanRules();
            },
        });
    }

    /**
     * Configurar event listeners
     */
    setupEventListeners() {
        if (this.plateField.length) {
            // Monitorar mudanças no campo de placa
            this.plateField.on("input keyup blur", () => {
                this.checkPlateCompletion();
            });
        }
    }

    /**
     * Aplicar regras baseadas no plano do usuário
     */
    applyPlanRules() {
        if (!this.userPlan) {
            return;
        }

        // Planos que devem ter campos bloqueados inicialmente: -1, 4, 5, 6
        const restrictedPlans = [-1, 4, 5, 6];

        if (restrictedPlans.includes(this.userPlan)) {
            this.lockFields();
        } else {
            // Planos 1, 2, 3 - campos sempre habilitados
            this.unlockFields();
        }
    }

    /**
     * Bloquear campos de marca e modelo
     */
    lockFields() {
        if (this.brandField.length) {
            this.brandField.prop("disabled", true);
            this.brandField.addClass("field-locked");
        }

        if (this.modelField.length) {
            this.modelField.prop("disabled", true);
            this.modelField.addClass("field-locked");
        }

        // Adicionar tooltip explicativo
        this.addTooltip();
    }

    /**
     * Desbloquear campos de marca e modelo
     */
    unlockFields() {
        if (this.brandField.length) {
            this.brandField.prop("disabled", false);
            this.brandField.removeClass("field-locked");
        }

        if (this.modelField.length) {
            this.modelField.prop("disabled", false);
            this.modelField.removeClass("field-locked");
        }

        this.removeTooltip();
    }

    /**
     * Verificar se a placa está completa
     */
    checkPlateCompletion() {
        if (!this.plateField.length) {
            return;
        }

        const plateValue = this.plateField.val().replace(/[^A-Z0-9]/g, "");
        const isPlateComplete = plateValue.length >= 7; // Placa completa tem 7 caracteres

        // Só desbloquear se for um plano restrito e a placa estiver completa
        const restrictedPlans = [-1, 4, 5, 6];
        if (restrictedPlans.includes(this.userPlan) && isPlateComplete) {
            this.unlockFields();
            this.showUnlockMessage();
        } else if (
            restrictedPlans.includes(this.userPlan) &&
            !isPlateComplete
        ) {
            this.lockFields();
        }
    }

    /**
     * Adicionar ícone de bloqueio
     */
    addLockIcon(field) {
        const fieldContainer = field.closest(".col-6, .col-md-3, .col-md-6");
        if (
            fieldContainer.length &&
            !fieldContainer.find(".lock-icon").length
        ) {
            const lockIcon = $(
                '<i class="lock-icon sg sg-lock" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); color: #6c757d; z-index: 10;"></i>',
            );
            fieldContainer.css("position", "relative");
            fieldContainer.append(lockIcon);
        }
    }

    /**
     * Remover ícone de bloqueio
     */
    removeLockIcon(field) {
        const fieldContainer = field.closest(".col-6, .col-md-3, .col-md-6");
        if (fieldContainer.length) {
            fieldContainer.find(".lock-icon").remove();
        }
    }

    /**
     * Adicionar tooltip explicativo
     */
    addTooltip() {
        if (
            this.brandField.length &&
            !this.brandField.attr("data-bs-original-title")
        ) {
            this.brandField.attr({
                "data-bs-toggle": "tooltip",
                "data-bs-placement": "top",
                title: "Preencha a placa completa para habilitar este campo",
            });

            // Inicializar tooltip do Bootstrap se disponível
            if (typeof bootstrap !== "undefined" && bootstrap.Tooltip) {
                new bootstrap.Tooltip(this.brandField[0]);
            }
        }
    }

    /**
     * Remover tooltip
     */
    removeTooltip() {
        if (this.brandField.length) {
            this.brandField.removeAttr(
                "data-bs-toggle data-bs-placement title data-bs-original-title",
            );

            // Destruir tooltip do Bootstrap se existir
            const tooltipInstance = bootstrap.Tooltip.getInstance(
                this.brandField[0],
            );
            if (tooltipInstance) {
                tooltipInstance.dispose();
            }
        }
    }

    /**
     * Mostrar mensagem de desbloqueio
     */
    showUnlockMessage() {
        // Remover mensagens informativas conforme solicitado
        // Não exibir mais notificações de desbloqueio
    }

    /**
     * Verificar se os campos devem estar bloqueados
     */
    shouldLockFields() {
        const restrictedPlans = ["gratuito"];
        return restrictedPlans.includes(this.userPlan);
    }

    /**
     * Obter status atual dos campos
     */
    getFieldsStatus() {
        return {
            userPlan: this.userPlan,
            fieldsLocked: this.shouldLockFields(),
            plateComplete: this.plateField.length
                ? this.plateField.val().replace(/[^A-Z0-9]/g, "").length >= 7
                : false,
        };
    }
}

// Exportar a classe
export { VehiclePlanController };

// Função para obter instância global
export function getVehiclePlanController() {
    if (!window.vehiclePlanController) {
        window.vehiclePlanController = new VehiclePlanController();
    }
    return window.vehiclePlanController;
}

// Criar instância global
window.vehiclePlanController = getVehiclePlanController();
